// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7by_e","col":"styles_col__2uwqM"};